import Ratings from '@kopapro/components/commons/ratings/ratings';

export default Ratings;
